import type { ActurisContactDetails } from 'api/quote-marketplace';

export const getFullName = (
  contact: Pick<
    ActurisContactDetails,
    'first_name' | 'last_name' | 'full_name'
  >,
): string => {
  const composed = [contact.first_name, contact.last_name]
    .filter(Boolean)
    .join(' ');

  return composed || contact.full_name;
};
